var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 95,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.905 48L95.1043 78.7033C91.6047 81.8877 87.0508 83.6484 82.3231 83.6701L72.2481 83.6919L72.2155 48H54V150H63.9337C69.4875 150 74.6717 147.055 77.3888 142.218C77.4106 142.186 77.4214 142.153 77.4432 142.131C79.2473 138.892 80.1494 132.491 79.9755 128.122C79.5842 118.134 77.9757 115.536 77.9757 115.536C77.6388 122.383 70.4874 122.753 70.4874 122.753C75.5738 117.895 72.8023 114.221 72.8023 114.221C63.7924 120.634 61.5427 113.786 61.3688 113.167C61.6514 113.406 64.2163 115.547 69.0853 108.874C74.237 101.82 81.1058 90.0607 85.4749 87.0393C89.8549 84.007 94.0066 84.257 94.0066 84.257C94.0066 84.257 96.3977 81.0182 102.723 78.3229C109.048 75.6492 113.102 79.5727 113.102 79.5727C106.636 84.7896 97.854 93.3539 97.3649 105.624C96.9737 115.558 118.384 132.6 114.624 157.771C116.874 152.054 117.776 146.326 117.004 139.24C116.385 133.523 112.7 121.579 112.7 121.579L133.263 149.989H156L111.559 88.9413L156 48H128.905Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4855 91.9192C86.0509 94.2994 86.0509 95.0276 86.0509 95.0276C86.0509 95.0276 91.0721 94.1798 92.4307 88.2131C92.4415 88.2131 89.2245 89.0391 87.4855 91.9192Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 209.623,
    y1: 191.383,
    x2: 114.031,
    y2: 0.572889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 95.7846,
    y1: 97.1142,
    x2: 89.8771,
    y2: 85.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKarIcon);
export default __webpack_public_path__ + "static/media/kar-icon.cb78f2cd.svg";
export { ForwardRef as ReactComponent };